/* eslint-disable no-restricted-syntax -- the rule redirects callers here, so this is where the math belongs */
export const Z_INDEX = {
  // One below the app bar: pinned banners that must clear in-route stacking
  // contexts (frozen DataGrid headers) while the fixed header always wins.
  BELOW_APP_BAR: theme => theme.zIndex.appBar - 1,
  APP_BAR: theme => theme.zIndex.appBar,
  DRAWER: theme => theme.zIndex.drawer,
  // Above the map's own controls, below modals: in-map progress and chrome.
  MAP_OVERLAY: theme => theme.zIndex.speedDial,
  FILTER_POPPER: theme => theme.zIndex.tooltip,
  LOADER: theme => theme.zIndex.modal + 3,
  NAVIGATION: theme => theme.zIndex.modal + 4,
  MENU: theme => theme.zIndex.modal + 5,
  SUBMENU: theme => theme.zIndex.modal + 6,
  ELEVATED_DIALOG: theme => theme.zIndex.modal + 10,
  ELEVATED_DIALOG_MENU: theme => theme.zIndex.modal + 20,
  // Above the drawer that opens it, so a photo viewer launched from a drawer is not trapped behind it.
  PHOTO_VIEWER: theme => theme.zIndex.snackbar,
  // The pickers the legacy bulk-move dialog opens over itself.
  ABOVE_SNACKBAR_DIALOG: theme => theme.zIndex.snackbar + 4,
  // MUI's own tooltip layer, which sits above modals rather than below them.
  TOOLTIP: theme => theme.zIndex.tooltip,
  BADGE_POPOVER: theme => theme.zIndex.tooltip + 1,
  // Absolute (not theme-relative): body-portaled map overlays that must float
  // above all app chrome, including MUI modals. A plain number so it also works
  // in raw inline `style` props where theme functions don't resolve.
  FLOATING_OVERLAY: 9999,
}
